import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type MovementOrderLineFragment = { __typename?: 'PendingTransferOrderLineDocument', lineItemId: string, materialItemId: string, materialItemName: string, materialItemErpId: string, quantity: number, organicLotCode?: string | null, isOrganicAtReceive: boolean, vendorLotNumber?: string | null };

export type MovementOrderFragment = { __typename?: 'PendingTransferOrderDocument', movementOrderId: string, transferOrderNumber: string, fromSiteLocationId: string, fromSiteLocationName: string, toSiteLocationId: string, toSiteLocationName: string, expectedDate: Types.TDateISO, status: Types.MovementOrderStatus, lines: Array<{ __typename?: 'PendingTransferOrderLineDocument', lineItemId: string, materialItemId: string, materialItemName: string, materialItemErpId: string, quantity: number, organicLotCode?: string | null, isOrganicAtReceive: boolean, vendorLotNumber?: string | null }> };

export type MovementOrderStateFragment = { __typename?: 'MovementOrderStateData', movementOrderId: string, status: Types.MovementOrderStatus };

export type MovementOrderHistoryLineFragment = { __typename?: 'MovementOrderHistoryLineDocument', lineItemId: string, materialItemId: string, quantity: number };

export type MovementOrderHistoryFragment = { __typename?: 'MovementOrderHistoryDocument', id: string, movementOrderId: string, transferOrderNumber: string, fromSiteLocationId: string, toSiteLocationId: string, fromSiteLocationName: string, toSiteLocationName: string, createdAt: Types.TDateISO, createdBy: string, shippedAt?: Types.TDateISO | null, shippedBy?: string | null, receivedAt?: Types.TDateISO | null, receivedBy?: string | null, status: Types.MovementOrderStatus, reasonName: string, requestedLines: Array<{ __typename?: 'MovementOrderHistoryLineDocument', lineItemId: string, materialItemId: string, quantity: number }>, shippedLines: Array<{ __typename?: 'MovementOrderHistoryLineDocument', lineItemId: string, materialItemId: string, quantity: number }>, receivedLines: Array<{ __typename?: 'MovementOrderHistoryLineDocument', lineItemId: string, materialItemId: string, quantity: number }> };

export type GetMovementOrderTransactionsByLocationQueryVariables = Types.Exact<{
  locationId: Types.Scalars['String']['input'];
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  where?: Types.InputMaybe<Types.MovementOrderHistoryDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.MovementOrderHistoryDocumentSortInput> | Types.MovementOrderHistoryDocumentSortInput>;
}>;


export type GetMovementOrderTransactionsByLocationQuery = { __typename?: 'Query', movementOrderTransactionsByLocation?: { __typename?: 'MovementOrderTransactionsConnection', totalCount: number, nodes?: Array<{ __typename?: 'MovementOrderHistoryDocument', id: string, movementOrderId: string, transferOrderNumber: string, fromSiteLocationId: string, toSiteLocationId: string, fromSiteLocationName: string, toSiteLocationName: string, createdAt: Types.TDateISO, createdBy: string, shippedAt?: Types.TDateISO | null, shippedBy?: string | null, receivedAt?: Types.TDateISO | null, receivedBy?: string | null, status: Types.MovementOrderStatus, reasonName: string, requestedLines: Array<{ __typename?: 'MovementOrderHistoryLineDocument', lineItemId: string, materialItemId: string, quantity: number }>, shippedLines: Array<{ __typename?: 'MovementOrderHistoryLineDocument', lineItemId: string, materialItemId: string, quantity: number }>, receivedLines: Array<{ __typename?: 'MovementOrderHistoryLineDocument', lineItemId: string, materialItemId: string, quantity: number }> }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetMovementOrderHistoryQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type GetMovementOrderHistoryQuery = { __typename?: 'Query', movementOrderHistory?: { __typename?: 'MovementOrderHistoryDocument', sourceBinId: string, destinationBinId: string, reasonCode: number, id: string, movementOrderId: string, transferOrderNumber: string, fromSiteLocationId: string, toSiteLocationId: string, fromSiteLocationName: string, toSiteLocationName: string, createdAt: Types.TDateISO, createdBy: string, shippedAt?: Types.TDateISO | null, shippedBy?: string | null, receivedAt?: Types.TDateISO | null, receivedBy?: string | null, status: Types.MovementOrderStatus, reasonName: string, requestedLines: Array<{ __typename?: 'MovementOrderHistoryLineDocument', isOrganicAtReceive: boolean, organicLotCode?: string | null, vendorLotNumber?: string | null, lineItemId: string, materialItemId: string, quantity: number }>, shippedLines: Array<{ __typename?: 'MovementOrderHistoryLineDocument', lineItemId: string, materialItemId: string, quantity: number }>, receivedLines: Array<{ __typename?: 'MovementOrderHistoryLineDocument', lineItemId: string, materialItemId: string, quantity: number }> } | null };

export type GetPendingTransferOrdersByDestinationQueryVariables = Types.Exact<{
  destinationLocationId: Types.Scalars['String']['input'];
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
  where?: Types.InputMaybe<Types.PendingTransferOrderDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.PendingTransferOrderDocumentSortInput> | Types.PendingTransferOrderDocumentSortInput>;
}>;


export type GetPendingTransferOrdersByDestinationQuery = { __typename?: 'Query', pendingTransferOrdersByDestination?: { __typename?: 'PendingTransferOrdersByDestinationConnection', totalCount: number, nodes?: Array<{ __typename?: 'PendingTransferOrderDocument', movementOrderId: string, transferOrderNumber: string, fromSiteLocationId: string, fromSiteLocationName: string, toSiteLocationId: string, toSiteLocationName: string, expectedDate: Types.TDateISO, status: Types.MovementOrderStatus, lines: Array<{ __typename?: 'PendingTransferOrderLineDocument', lineItemId: string, materialItemId: string, materialItemName: string, materialItemErpId: string, quantity: number, organicLotCode?: string | null, isOrganicAtReceive: boolean, vendorLotNumber?: string | null }> }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export const MovementOrderLineFragmentDoc = new TypedDocumentString(`
    fragment MovementOrderLine on PendingTransferOrderLineDocument {
  lineItemId
  materialItemId
  materialItemName
  materialItemErpId
  quantity
  organicLotCode
  isOrganicAtReceive
  vendorLotNumber
}
    `, {"fragmentName":"MovementOrderLine"});
export const MovementOrderFragmentDoc = new TypedDocumentString(`
    fragment MovementOrder on PendingTransferOrderDocument {
  movementOrderId
  transferOrderNumber
  fromSiteLocationId
  fromSiteLocationName
  toSiteLocationId
  toSiteLocationName
  expectedDate
  status
  lines {
    ...MovementOrderLine
  }
}
    fragment MovementOrderLine on PendingTransferOrderLineDocument {
  lineItemId
  materialItemId
  materialItemName
  materialItemErpId
  quantity
  organicLotCode
  isOrganicAtReceive
  vendorLotNumber
}`, {"fragmentName":"MovementOrder"});
export const MovementOrderStateFragmentDoc = new TypedDocumentString(`
    fragment MovementOrderState on MovementOrderStateData {
  movementOrderId
  status
}
    `, {"fragmentName":"MovementOrderState"});
export const MovementOrderHistoryLineFragmentDoc = new TypedDocumentString(`
    fragment MovementOrderHistoryLine on MovementOrderHistoryLineDocument {
  lineItemId
  materialItemId
  quantity
}
    `, {"fragmentName":"MovementOrderHistoryLine"});
export const MovementOrderHistoryFragmentDoc = new TypedDocumentString(`
    fragment MovementOrderHistory on MovementOrderHistoryDocument {
  id
  movementOrderId
  transferOrderNumber
  fromSiteLocationId
  toSiteLocationId
  fromSiteLocationName
  toSiteLocationName
  createdAt
  createdBy
  shippedAt
  shippedBy
  receivedAt
  receivedBy
  requestedLines {
    ...MovementOrderHistoryLine
  }
  shippedLines {
    ...MovementOrderHistoryLine
  }
  receivedLines {
    ...MovementOrderHistoryLine
  }
  status
  reasonName
}
    fragment MovementOrderHistoryLine on MovementOrderHistoryLineDocument {
  lineItemId
  materialItemId
  quantity
}`, {"fragmentName":"MovementOrderHistory"});
export const GetMovementOrderTransactionsByLocationDocument = new TypedDocumentString(`
    query GetMovementOrderTransactionsByLocation($locationId: String!, $first: Int, $after: String, $where: MovementOrderHistoryDocumentFilterInput, $order: [MovementOrderHistoryDocumentSortInput!]) {
  movementOrderTransactionsByLocation(
    locationId: $locationId
    first: $first
    after: $after
    where: $where
    order: $order
  ) {
    nodes {
      ...MovementOrderHistory
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment MovementOrderHistoryLine on MovementOrderHistoryLineDocument {
  lineItemId
  materialItemId
  quantity
}
fragment MovementOrderHistory on MovementOrderHistoryDocument {
  id
  movementOrderId
  transferOrderNumber
  fromSiteLocationId
  toSiteLocationId
  fromSiteLocationName
  toSiteLocationName
  createdAt
  createdBy
  shippedAt
  shippedBy
  receivedAt
  receivedBy
  requestedLines {
    ...MovementOrderHistoryLine
  }
  shippedLines {
    ...MovementOrderHistoryLine
  }
  receivedLines {
    ...MovementOrderHistoryLine
  }
  status
  reasonName
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetMovementOrderHistoryDocument = new TypedDocumentString(`
    query GetMovementOrderHistory($id: String!) {
  movementOrderHistory(id: $id) {
    ...MovementOrderHistory
    sourceBinId
    destinationBinId
    reasonCode
    requestedLines {
      isOrganicAtReceive
      organicLotCode
      vendorLotNumber
    }
  }
}
    fragment MovementOrderHistoryLine on MovementOrderHistoryLineDocument {
  lineItemId
  materialItemId
  quantity
}
fragment MovementOrderHistory on MovementOrderHistoryDocument {
  id
  movementOrderId
  transferOrderNumber
  fromSiteLocationId
  toSiteLocationId
  fromSiteLocationName
  toSiteLocationName
  createdAt
  createdBy
  shippedAt
  shippedBy
  receivedAt
  receivedBy
  requestedLines {
    ...MovementOrderHistoryLine
  }
  shippedLines {
    ...MovementOrderHistoryLine
  }
  receivedLines {
    ...MovementOrderHistoryLine
  }
  status
  reasonName
}`);
export const GetPendingTransferOrdersByDestinationDocument = new TypedDocumentString(`
    query GetPendingTransferOrdersByDestination($destinationLocationId: String!, $first: Int, $after: String, $last: Int, $before: String, $where: PendingTransferOrderDocumentFilterInput, $order: [PendingTransferOrderDocumentSortInput!]) {
  pendingTransferOrdersByDestination(
    destinationLocationId: $destinationLocationId
    first: $first
    after: $after
    last: $last
    before: $before
    where: $where
    order: $order
  ) {
    nodes {
      ...MovementOrder
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment MovementOrderLine on PendingTransferOrderLineDocument {
  lineItemId
  materialItemId
  materialItemName
  materialItemErpId
  quantity
  organicLotCode
  isOrganicAtReceive
  vendorLotNumber
}
fragment MovementOrder on PendingTransferOrderDocument {
  movementOrderId
  transferOrderNumber
  fromSiteLocationId
  fromSiteLocationName
  toSiteLocationId
  toSiteLocationName
  expectedDate
  status
  lines {
    ...MovementOrderLine
  }
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetMovementOrderTransactionsByLocation: build.query<GetMovementOrderTransactionsByLocationQuery, GetMovementOrderTransactionsByLocationQueryVariables>({
      query: (variables) => ({ document: GetMovementOrderTransactionsByLocationDocument, variables })
    }),
    GetMovementOrderHistory: build.query<GetMovementOrderHistoryQuery, GetMovementOrderHistoryQueryVariables>({
      query: (variables) => ({ document: GetMovementOrderHistoryDocument, variables })
    }),
    GetPendingTransferOrdersByDestination: build.query<GetPendingTransferOrdersByDestinationQuery, GetPendingTransferOrdersByDestinationQueryVariables>({
      query: (variables) => ({ document: GetPendingTransferOrdersByDestinationDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetMovementOrderTransactionsByLocationQuery, useLazyGetMovementOrderTransactionsByLocationQuery, useGetMovementOrderHistoryQuery, useLazyGetMovementOrderHistoryQuery, useGetPendingTransferOrdersByDestinationQuery, useLazyGetPendingTransferOrdersByDestinationQuery } = injectedRtkApi;
